import React from "react";

export interface CourseBannerProps {
  heading: string;
  desc?: string;
}

export default function CourseBanner(props: CourseBannerProps) {
  return (
    <>
      <div className="w-100 courses_bg d-flex flex-column justify-content-center">
        <div className="container-xxl px-lg-5  text-white">
          <h1 className="fw-bold">{props.heading}</h1>
          <h6 className="fw-bold">{props.desc}</h6>
        </div>
      </div>
    </>
  );
}
